/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type { Link } from 'ember-link';
import type ModalService from 'walden-fast/services/modal';
import { SUPPORT_EMAIL } from 'walden-fast/constants/utils';

export interface NavigationTree {
  groups: {
    groupName?: string;
    items: {
      featureEnabled?: boolean;
      label: string;
      canAccessService?: boolean;
      link?: Link;
    }[];
  }[];
}

export interface SidebarSignature {
  // The arguments accepted by the component
  Args: {
    chatEnabled: boolean;
    navigationTree: NavigationTree;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: HTMLElement;
}

// const SidebarComponent = templateOnlyComponent<SidebarSignature>();
export default class SidebarComponent extends Component<SidebarSignature> {
  @service('modal') declare modal: ModalService;

  phoneInfoModal = 'phone-info';

  get supportEmail() {
    return SUPPORT_EMAIL;
  }

  @action
  openPhoneInfoModal() {
    this.modal.open(this.phoneInfoModal);
  }

  get shownGroups() {
    const groupsWithEnabledItems = this.args.navigationTree.groups.map(
      (group) => ({
        ...group,
        items: group.items.filter(
          (item) =>
            item.featureEnabled === true || item.featureEnabled === undefined,
        ),
      }),
    );
    return groupsWithEnabledItems.filter((group) => {
      return group.items.length;
    });
  }
}
